import { render, staticRenderFns } from "./CabeceraModalCreacion.vue?vue&type=template&id=6ad05968&scoped=true&"
import script from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCreacion.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalCreacion.vue?vue&type=style&index=0&id=6ad05968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad05968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ad05968', component.options)
    } else {
      api.reload('6ad05968', component.options)
    }
    module.hot.accept("./CabeceraModalCreacion.vue?vue&type=template&id=6ad05968&scoped=true&", function () {
      api.rerender('6ad05968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ConfigAutorizaciones/CabeceraModalCreacion.vue"
export default component.exports